/* eslint-disable class-methods-use-this */
import {
  GROUPING_TYPE,
  WDH_GROUPING_TYPE,
} from 'utils/__enums/Administration/Organization'
import { HierarchyEntity } from 'utils/__interfaces/Administrations/Organizations/ManageOrganization'
import OrganizationWDH from 'utils/__interfaces/Administrations/Organizations/OrganizationWDH'

class HierarchyNormalizer {
  normalize(organizationList: OrganizationWDH[]): HierarchyEntity[] {
    return organizationList.map(
      ({
        idOrganisation,
        nomOrganisation,
        organisationsEnfant,
        nbContrats,
        typeOrganisation,
      }) => {
        return {
          id: String(idOrganisation),
          name: nomOrganisation,
          childrenOrganization: organisationsEnfant.map(
            ({ fkorganisationenfant }) =>
              fkorganisationenfant.replace('/organisations/', '')
          ),
          nbEtablissementEnfant: nbContrats ?? 0,
          typeOrganisation:
            typeOrganisation === WDH_GROUPING_TYPE.WHD_BY_ORGANIZATION
              ? GROUPING_TYPE.BY_ORGANIZATION
              : GROUPING_TYPE.BY_INSTITUTION,
        }
      }
    )
  }
}

export default new HierarchyNormalizer()
